/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {Container} from "reactstrap";


import {Link, useParams} from "react-router-dom";
import Pagecontent from "./pagecontent";
import ApiService from "../util/ApiService";
import Skeleton from "react-loading-skeleton";
import ContentHospital from "./ContentHospital"; // Importando o Skeleton

import LoadingScreen from "../util/LoadingScreen";

const HospitalDetail = (props) => {

    const {url} = useParams(); // Captura o token da URL
    const [loading, setLoading] = useState(true);
    const [loadingPage, setLoadingPage] = useState(false);
    const [hospital, setHospital] = useState(null);
    const [ratings, setRatings] = useState(null);
    const [noResults, setNoResults] = useState(false);

    useEffect(() => {
        fetchHospitalData();
    }, [url]);

    const fetchHospitalData = () => {
        setLoading(true);
        ApiService.send(
            "get",
            `${process.env.REACT_APP_URL_API}page-detail/hospital/${url}`,
            {},
            false
        )
            .then((response) => {

                const {data} = ApiService.handleApiResponse(response);

                setHospital(data.hospital);
                setRatings(data.ratings);
            })
            .catch((error) => {
                console.error("Failed to fetch duties:", error);
                setNoResults(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>

            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Detalhes" pageTitle="Hospital"/>

                        {loadingPage && <LoadingScreen/>}

                        <div className="breadcrumb-bar-two" style={{
                            position: 'relative',
                            backgroundImage: `url(${hospital?.images[0]?.file || process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            height: '190px',
                        }}>
                            <div style={{
                                height: '190px',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(255, 255, 255, 0.87)',
                                zIndex: 1
                            }}></div>

                            <div className="" style={{position: 'relative', zIndex: 2}}>
                                <div className="row align-items-center inner-banner text-center">
                                    <div className="col-md-12 col-12 mt-6 m-5">
                                        <h2 className="hospital-name">
                                            {loading ? <Skeleton width={300}
                                                                 height={40}/> : hospital ? hospital.social_reason : 'Detalhes'}
                                        </h2>
                                        <nav aria-label="breadcrumb" className="page-breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <Link to="/">Home</Link>
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Hospital detalhes
                                                </li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div>
                                <div>
                                    {loading ? (
                                        <Skeleton height={200}/>
                                    ) : (
                                        <Pagecontent hospital={hospital}/>
                                    )}
                                </div>

                                <div className=" shadow-sm mt-4">
                                    {loading ? (
                                        <Skeleton count={3} height={150}/>
                                    ) : (
                                        <ContentHospital
                                            hospital={hospital}
                                            ratings={ratings}
                                            loading={loading}
                                            loadingPage={loadingPage}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>


                    </Container>
                </div>
            </React.Fragment>
        </>
    )
        ;
};

export default HospitalDetail;
